import { render, staticRenderFns } from "./BaseInhalt.vue?vue&type=template&id=65f71740&"
import script from "./BaseInhalt.vue?vue&type=script&lang=js&"
export * from "./BaseInhalt.vue?vue&type=script&lang=js&"
import style0 from "./BaseInhalt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports